import { render } from "./CadastroInicio.vue?vue&type=template&id=2982acc4"
import script from "./CadastroInicio.vue?vue&type=script&lang=js"
export * from "./CadastroInicio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__